module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_NR_KONTA.386e2e69.mp3";